import React from "react";
import classes from "./CircleLoading.scss";

const LOADER_SIZE = {
  "x-small": "24px",
  medium: "32px",
  small: "28px",
  large: "36px",
};

const CircleLoading = props => {
  const {
    size = "medium",
    loaderStyles,
    strokeColor = "#090909ff",
    backgroundColor,
    svgWidth = "16px",
    svgHeight = "16px",
  } = props;

  const loaderWrapperStyles = {
    width: LOADER_SIZE[size],
    height: LOADER_SIZE[size],
    ...(backgroundColor && { backgroundColor }),
    ...loaderStyles,
  };

  return (
    <div
      className={classes.loaderContainer}
      style={loaderWrapperStyles}
      onClick={e => e.stopPropagation()}
      role="button"
      tabIndex={0}
      onKeyDown={e => {
        // Prevent default for Enter or Space key
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          e.stopPropagation();
        }
      }}
      aria-label={`Loading indicator`}
    >
      <svg
        width={svgWidth}
        height={svgHeight}
        viewBox="0 0 50 50"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke={strokeColor}
          strokeWidth="4"
          strokeLinecap="round"
          strokeDasharray="90,150"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 25 25"
            to="360 25 25"
            dur="1s"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
    </div>
  );
};

export default CircleLoading;
